
import {DynamicModal} from './DynamicModal';
import {PwChange} from '../user';
import {mix} from 'argo-js/src/common/mixwith';
import {BaseModel} from 'argo-js/src/data';
import {ModelViewMixin} from 'argo-js/src/mixin';

const tpl = require('../templates/changePassword.hbs');

/**
 * Build a new Modal for Change Password, after the user click on the link
 */
export class ChangePasswordModal extends mix(DynamicModal).with(ModelViewMixin) {

  constructor(config) {
    super($.extend(true, {
      id: 'modalPwReset',
      credentials: {}, // preset credentials
      message: null,   // alert message to be displayed
      i18n: {
        ns: 'changePassModal.'
      },
      settings: {
        css: false,
        fade: true,
        contentTag: 'form',
        contentCss: '',
        title: 'title',
        hideClose: false,
        closeLabel: 'modal.closeLabel',
        dataComponent: 'user.pwchange'
      },
      modelView: {
        tpl,
        wrapper: '@body',
      },
      data: BaseModel.create({
        data: {
          message: config.message,
          passwordRequired: !config.credentials.password
        }
      })
    }, config));
  }

  onShow() {

    // remove any aborting methods
    if (this.config.preventClose) {
      this.el.find('[data-dismiss]').hide();
    }

    new PwChange({
      app: this.app,
      el: this.el,
      credentials: this.config.credentials,
      on: {
        success: (credentials) => {
          this.config.credentials = credentials;
          this.close();
        }
      }
    });

  }

}